module.exports = __webpack_public_path__ + "img/NYI Barclay Bingo.83cabe74.jpeg";